export const LimitMobile = 8;
export const LimitDesktop = 12;
